import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-warning",
  "use": "icon-warning-usage",
  "viewBox": "0 0 18 17",
  "content": "<symbol viewBox=\"0 0 18 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-warning\">\n<path d=\"M9.0013 0.166992C4.4013 0.166992 0.667969 3.90033 0.667969 8.50033C0.667969 13.1003 4.4013 16.8337 9.0013 16.8337C13.6013 16.8337 17.3346 13.1003 17.3346 8.50033C17.3346 3.90033 13.6013 0.166992 9.0013 0.166992ZM9.83464 12.667H8.16797V7.66699H9.83464V12.667ZM9.83464 6.00033H8.16797V4.33366H9.83464V6.00033Z\" fill=\"#E2211C\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol